export function defaultNotificationDataInjector(fallBackNotificationData) {
  const variablesForUse = fallBackNotificationData.variablesForUse

  fallBackNotificationData.setOnClick((notificationDataFromComponent) => {
    variablesForUse.navigate(`/`)
  })
}
